export default "/img/GD.1f5933c7cc30a823ad00eb517ceaa6b7.png";